<template>
  <v-card class="mt-6">
    <v-data-table
      :headers=headers
      :items="datatableItems"
      :search="search"
      :loading="loadingList"
      hide-default-footer
      item-key="id + 1"
    >
      <template v-slot:top>
        <div class="row no-gutters d-flex align-start pa-3">
          <v-col cols="12" md="4" sm="4" :class="{ 'pb-4' : isXsmall }">
            <v-autocomplete
              id="autoComplete"
              v-model="selectedTags"
              :items="listTags"
              :menu-props="{
                offsetY: true
              }"
              solo-inverted
              dense
              chips
              color="blue-grey lighten-2"
              :label="selectTagsLabel"
              item-text="title"
              item-value="id"
              multiple
              hide-details
              @click="scrollToInput"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-if="data.index === 0"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                >
                  {{ data.item.title }}
                </v-chip>
                <span
                  v-if="data.index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ selectedTags.length - 1 }} others)
                </span>
              </template>
              <template v-slot:item="data">
                {{ data.item.title }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
              @click:clear="clearSearchInput()"
            ></v-text-field>

            <GroupExport class="mt-4" />
            <SaveFilter
              class="mt-4 text-right"
              :disabledFromParent="selectedTagsIsEmpty"
            />
          </v-col>
        </div>
      </template>

      <template v-slot:[`item.id`]="{ item }">
        {{ item.id }}
      </template>

      <template v-slot:[`item.tags`]="{ item }">
        {{ item.tag_title }}
      </template>
    </v-data-table>
    <v-pagination
      v-if="!isSearching"
      v-model="page"
      :length="pageCount"
      :total-visible="7"
      :disabled="pageCount == 1"
      class="py-3"
    ></v-pagination>
  </v-card>
</template>

<script>
import GroupExport from '@/components/common/filters/GroupExport.vue';
import SaveFilter from '@/components/common/saveFilters/index.vue';

export default {
  name: "datatable-list-players-by-tags",

  props: {
    listTags: {
      type: Array
    }
  },

  components: {
    GroupExport,
    SaveFilter,
  },

  data: () => ({
    search: "",
    selectedTags: "",
    datatableItems: [],
    loadingList: false,
    headers: [
      { text: "Último login", value: "ultimo_login", align: "no-wrap" },
      { text: "Tags", value: "tag_title", align: "no-wrap" },
      { text: "ID", value: "id", align: "no-wrap" },
      { text: "Nome", value: "nome", align: "no-wrap" },
      { text: "Login", value: "login", align: "no-wrap" },
      { text: "Data cadastro", value: "data_cadastro", align: "no-wrap" },
      { text: "Email", value: "email", align: "no-wrap" },
      { text: "Celular", value: "celular", align: "no-wrap" },
      { text: "Saldo online", value: "saldo_online", align: "no-wrap" },
      { text: "Saldo bonus", value: "saldo_bonus", align: "no-wrap" },
      { text: "ID afiliado", value: "id_afiliado", align: "no-wrap" },
    ],
    // Pagination
    page: 1,
    nextPage: null,
    pageCount: 1,
    cachedPage: {},
    isSearching: false,
  }),

  computed: {
    selectTagsLabel() {
      return this.$t("selectTags");
    },
    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    selectedTagsIsEmpty() {
      return this.selectedTags == "";
    }
  },

  watch: {
    saveFilters(bool) {
      bool && this.listPlayersByTags()
    },

    page() {
      this.listPlayersByTags(true);
    },

    selectedTags() {
      this.search = "";
      this.cachedPage = {};
      this.page = 1;
      this.pageCount = 1;
      this.datatableItems = [];
    },

    search(string) {
      this.filterPages(string);
    },
  },

  methods: {
    stopSearching() {
      this.search = "";
      this.isSearching = false;
      this.datatableItems = this.cachedPage[this.page];
    },

    clearSearchInput() {
      this.stopSearching();
    },

    listPlayersByTags(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }

      const body = {
        tags: this.selectedTags,
        page: this.page,
        export: this.exportDoc, // "", csv, xlsx
      };

      if (this.exportDoc && !isChangingPage) {
        // no export precisamos passar page 1,
        // vamos receber os dados de todas as páginas
        body.page = 1;
        this.$request.exportDoc(
          `${this.$prefix()}/tags/listOnlinePlayersbyTags`,
          body,
          this.exportDoc,
        );
        this.loadingList = false;
        return
      }

      this.loadingList = true;
      this.datatableItems = [];

      if (this.cachedPage[this.page]) {
        this.datatableItems = this.cachedPage[this.page]
        this.loadingList = false;
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        return
      }

      this.$axios
        .post(`${this.$prefix()}/tags/listOnlinePlayersbyTags`, this.$formdata(body))
        .then((resp) => {
          this.loadingList = false;
          const currentPage = resp.data.this_page;
          const nextPage = resp.data.next_page;
          if (currentPage && nextPage) {
            this.nextPage = nextPage;
            this.pageCount = this.nextPage;
          } else {
            this.nextPage = null;
          }

          this.datatableItems = resp.data.dados;
          
          this.datatableItems.forEach((item) => {
            item.ultimo_login = this.$handleDate(item.ultimo_login).date
            item.data_cadastro = this.$handleDate(item.data_cadastro).date
          })

          this.cachedPage[this.page] = this.datatableItems;
        })
        .catch(() => {
          this.loadingList = false;
        })
    },

    filterPages(searchString) {
      const searchStrToLowerCase = searchString && searchString.toLowerCase()
      const matches = [];

      for (const key in this.cachedPage) {
        const arrayObjects = this.cachedPage[key];

        for (const object of arrayObjects) {
          for (const prop in object) {
            if (object[prop] && object[prop].toLowerCase().includes(searchStrToLowerCase)) {
              matches.push({ key, object });
              break; // Para evitar que o mesmo objeto seja adicionado várias vezes
            }
          }
        }
      }
      
      if (searchStrToLowerCase) {
        this.isSearching = true;
        this.datatableItems = matches.map((item) => item.object);
      } else {
        this.stopSearching();
      }
    },

    remove (item) {
      const index = this.selectedTags.indexOf(item.tag_id)
      if (index >= 0) this.selectedTags.splice(index, 1)
    },

    scrollToInput() {
      if (!this.isXsmall) return
      document
        .getElementById("autoComplete")
        .scrollIntoView({ behavior: "smooth" });
    },
  }
}
</script>